import React from 'react';

import { useIntl } from 'react-intl';

import { IconButton } from '@atlaskit/button/new';
import MicrophoneIcon from '@atlaskit/icon/core/microphone';

import messages from './messages';

export const VoiceMicrophoneButton = ({ onClick }: { onClick: () => void }): React.JSX.Element => {
	const { formatMessage } = useIntl();

	return (
		<IconButton
			shape="circle"
			isTooltipDisabled={false}
			icon={(iconProps) => <MicrophoneIcon {...iconProps} label={''} />}
			appearance="subtle"
			onClick={onClick}
			label={formatMessage(messages.voiceDictationButtonLabel)}
		/>
	);
};
